var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.693 2h-13.386c-1.825 0.003-3.304 1.482-3.307 3.307v13.386c0.003 1.825 1.482 3.304 3.307 3.307h13.386c1.826-0.002 3.305-1.482 3.307-3.307v-13.383c-0.001-1.827-1.48-3.308-3.307-3.31h-0zM20.11 18.693c-0.001 0.782-0.635 1.416-1.417 1.417h-13.386c-0.782-0.001-1.416-0.635-1.417-1.417v-10.315h3.070v0.846c-0.563 0.272-0.945 0.838-0.945 1.494 0 0.913 0.741 1.654 1.654 1.654s1.654-0.741 1.654-1.654c0-0.656-0.382-1.223-0.935-1.49l-0.010-0.004v-0.846h7.244v0.846c-0.564 0.272-0.945 0.839-0.945 1.495 0 0.913 0.741 1.654 1.654 1.654s1.654-0.741 1.654-1.654c0-0.656-0.382-1.223-0.936-1.49l-0.010-0.004v-0.846h3.071zM20.11 6.961h-3.071v-0.974c0-0.391-0.317-0.708-0.708-0.708s-0.708 0.317-0.708 0.708v0 0.974h-7.244v-0.974c0-0.392-0.317-0.709-0.709-0.709s-0.709 0.317-0.709 0.709v0 0.974h-3.070v-1.651c0.001-0.782 0.635-1.416 1.417-1.417h13.386c0.782 0.001 1.416 0.635 1.417 1.417v0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.86d7ba8f.svg";
export { ForwardRef as ReactComponent };